/**
 * 驗證是否為合法手機號
 *
 * @param {string} phoneVal 欲驗證的手機號
 * @returns {boolean} 手機號是否合法
 */
export const isValidCellphone = (phoneVal) => {
  const cellphoneRegex = /^09\d{8}$/g

  return cellphoneRegex.test(phoneVal)
}

/**
 * 驗證是否為合法手機號(前頭不含零)
 * - 可用來判斷後續是否需補零
 *
 * @param {string} phoneVal 欲驗證的手機號
 * @returns {boolean} 手機號是否合法
 */
export const isValidCellphoneNotContainZero = (phoneVal) => {
  const cellphoneRegex = /^9\d{8}$/g

  return cellphoneRegex.test(phoneVal)
}
